import RootRequest from "./RootRequest";

export default class ShipperBranchRequest extends RootRequest {
  get apiResource() {
    return "api/shipper-branch";
  }
}

export const shipperBranchRequest = new ShipperBranchRequest();
